module.exports = __webpack_public_path__ + "media/components/lesson4/common/statics/connectBlock-b36e4ec0fbdd7c36f27819d18e806afa.gif";